import { convertDateToStandardFormat } from '../../../../utils/dateHelper';

export const getDates = (date, values, singleDate) => {
  const formattedDate = date ? convertDateToStandardFormat(date) : null;
  if (values.includes(formattedDate)) return values.filter(v => v !== formattedDate);
  if (singleDate) return [formattedDate];
  return [...values, formattedDate];
};
